import React from 'react';
import toast from 'react-hot-toast';
import {
  Box,
  Card,
  CardContent,
  Stack,
  Typography,
  Divider,
  Link,
  Button
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useParameterizedQuery } from 'react-fetching-library';
import { clientQualificationCardAction } from '../../services/request';

export default function QualificationCardSent({ identifier, data, password }) {
  const { loading, query } = useParameterizedQuery(clientQualificationCardAction);

  const handleLinkClick = link => {
    window.open(link, '_blank');
  };

  const handleDownload = async () => {
    const {
      error: queryError,
      loading: queryLoading,
      payload: queryPayload
    } = await query(data.order_id, 'download', password);

    if (!queryError && !queryLoading) {
      const url = window.URL.createObjectURL(queryPayload);
      const a = document.createElement('a');

      document.body.appendChild(a);

      a.style = 'display: none';
      a.href = url;
      a.download = 'Karta kwalifikacyjna.pdf';

      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } else {
      toast.error('Nie udało się pobrać pliku');
    }
  };

  const handleSendEmail = async () => {
    const {
      error: queryError,
      loading: queryLoading
    } = await query(data.order_id, 'email', password);

    if (!queryError && !queryLoading) {
      toast.success('Wysłano mail z kartą kwalifikacyjną');
    } else {
      toast.error('Nie udało się wysłać maila z kartą kwalifikacyjną');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: {
          xs: '95vh',
          md: 'auto'
        }
      }}
    >
      <Card
        sx={{
          width: {
            xs: '100%',
            md: 'auto'
          },
          boxShadow: {
            xs: 'none',
            md: undefined
          }
        }}
      >
        <CardContent
          sx={{
            px: {
              xs: 0,
              md: 2
            }
          }}
        >
          <Stack
            justifyContent="center"
            alignItems="center"
            spacing={0}
          >
            <CheckCircleOutlineIcon
              color="primary"
              sx={{
                fontSize: {
                  xs: 72,
                  md: 100
                },
                mb: {
                  xs: 0,
                  md: 3
                }
              }}
            />

            <Typography
              variant="h3"
              textAlign="center"
              whiteSpace="pre-line"
            >
              {'Dokument został wysłany na Twój adres e-mail.\n\nWYDRUKUJ GO ➞ PODPISZ ➞ ZESKANUJ ➞ WYŚLIJ NA ADRES '}
              {data.resort_email_address && (
                <Link
                  href={`mailto:${data.resort_email_address}`}
                  color="primary"
                >
                  {data.resort_email_address.toUpperCase()}
                </Link>
              )}
              {`\nPAMIĘTAJ, ŻE MASZ CZAS OGRANICZONY DO ${data.completing_date_to}\n`}
            </Typography>

            <Box
              sx={{
                height: {
                  xs: 20,
                  md: 40
                }
              }}
            />

            <Stack
              direction="column"
              alignItems="center"
              mb={1}
              mt={{
                xs: 0,
                md: 2
              }}
            >
              <Stack direction="row">
                <Button
                  sx={{ mr: 2 }}
                  variant="contained"
                  size="large"
                  onClick={handleDownload}
                  disabled={loading}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        xs: 16,
                        md: 'inherit'
                      }
                    }}
                  >
                    <Box
                      component="span"
                    >
                      POBIERZ
                    </Box>
                  </Typography>
                </Button>

                <Button
                  variant="contained"
                  size="large"
                  onClick={handleSendEmail}
                  disabled={loading}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        xs: 16,
                        md: 'inherit'
                      }
                    }}
                  >
                    <Box
                      component="span"
                    >
                      WYŚLIJ NA SWÓJ @
                    </Box>
                  </Typography>
                </Button>
              </Stack>

              <Button
                sx={{
                  mt: 6,
                  justifyContent: 'left'
                }}
                variant="contained"
                size="large"
                onClick={() => handleLinkClick(
                  'https://sun-sport.pl/lato/strefa-rodzica#ubezpieczenie'
                )
                }
              >
                <Typography
                  sx={{
                    fontSize: {
                      xs: 16,
                      md: 'inherit'
                    }
                  }}
                >
                  MOŻESZ JESZCZE ROZWAŻYĆ
                  <br />
                  UBEZPIECZENIE REZYGNACJI Z WYJAZDU
                </Typography>
              </Button>
            </Stack>

            <Box
              sx={{
                height: {
                  xs: 40,
                  md: 80
                }
              }}
            />

            <Stack
              direction="column"
              justifyContent="center"
              alignItems="center"
            >
              <Divider sx={{ width: '100%' }} />

              <Box height={10} />

              <Typography
                textAlign="center"
                sx={{
                  fontSize: {
                    xs: 22,
                    md: 24
                  }
                }}
              >
                <i>
                  W międzyczasie obserwuj nas i zawsze bądź na bieżąco
                </i>
              </Typography>

              <Stack direction="row" gap={2}>
                <a
                  style={{
                    height: '80px',
                    color: '#4267B2'
                  }}
                  href="https://www.facebook.com/kalisz.sun.sport"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FacebookRoundedIcon
                    sx={{
                      fontSize: {
                        xs: 60,
                        md: 80
                      }
                    }}
                  />
                </a>

                <a
                  style={{ height: '80px' }}
                  href="https://www.instagram.com/sun_sport.pl/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg width={0} height={0}>
                    <radialGradient
                      id="rg"
                      r="150%"
                      cx="30%"
                      cy="107%"
                    >
                      <stop stopColor="#fdf497" offset="0" />
                      <stop stopColor="#fdf497" offset="0.05" />
                      <stop stopColor="#fd5949" offset="0.45" />
                      <stop stopColor="#d6249f" offset="0.6" />
                      <stop stopColor="#285AEB" offset="0.9" />
                    </radialGradient>
                  </svg>

                  <InstagramIcon
                    sx={{
                      fill: 'url(#rg)',
                      fontSize: {
                        xs: 60,
                        md: 80
                      }
                    }}
                  />
                </a>

                <a
                  style={{
                    height: '80px',
                    color: 'red'
                  }}
                  href="https://www.youtube.com/@sun_sport_obozy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <YouTubeIcon
                    sx={{
                      fontSize: {
                        xs: 60,
                        md: 80
                      }
                    }}
                  />
                </a>
              </Stack>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
